export const REPORTS_PERMISSION_CODES = {
  SCORING_BY_LAWYERS: 'INFORMES.SCORING_POR_ABOGADOS',
  SCORING_BY_LAWYERS_VIEW_SECTION: 'INFORMES.VER_SECCION_147',
  SCORING_BY_LAWYERS_DOWNLOAD_EXCEL: 'INFORMES.DESCARGAR_EXCEL_148',
  TEMPLATE_USAGE: 'INFORMES.USO_DE_PLANTILLAS',
  TEMPLATE_USAGE_VIEW_SECTION: 'INFORMES.VER_SECCION_150',
  TEMPLATE_USAGE_DOWNLOAD_EXCEL: 'INFORMES.DESCARGAR_EXCEL_151',
  DETECTION_AND_MONITORING: 'INFORMES.DETECCION_Y_MONITOREO',
  DETECTION_AND_MONITORING_VIEW_SECTION: 'INFORMES.VER_SECCION_153',
  DETECTION_AND_MONITORING_DOWNLOAD_EXCEL: 'INFORMES.DESCARGAR_EXCEL_154',
  DETECTION_AND_MONITORING_MANAGE: 'INFORMES.GESTIONAR',
};
